import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";

import Swal from "sweetalert2";
import "../AdminDashboard.css";
import { useNavigate } from "react-router-dom";
import NoIndex from "../../NoIndex";

import "../AdminDashboard.css";
import { FaKey, FaWallet, FaReport, FaTable } from "react-icons/fa";

import { Tab, Nav, Form, Button, Row, Col } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import {
  faUser,
  faPen,
  faMoneyBillTransfer,
  faFileLines

} from "@fortawesome/free-solid-svg-icons";
import { FaWhatsapp } from "react-icons/fa";

import "react-datepicker/dist/react-datepicker.css";

import MyContext from "../../../MyContext"; //using ContextAPI to store data dynamically

const ClientAccordionTable = ({ Admin }) => {
  const { baseUrl, config } = useContext(MyContext);
  const [transactions, settransactions] = useState([])
  const [openRows, setOpenRows] = useState({});
  const [Clients, setClients] = useState([]);

  const [error, setError] = useState(null);
  const [latitude, setLatitude] = useState(null);
  const [longitude, setLongitude] = useState(null);
  const [userID, setuserID] = useState("");
  const [Lerror, setLerror] = useState(null);
  const [User, setUser] = useState({});
  const [name, setName] = useState("");
  const [appId, setAppId] = useState("");
  const [businessAccId, setBusinessAccId] = useState("");
  const [token, setToken] = useState("");
  const [phoneNo, setPhoneNo] = useState("");
  const [Credentials, setCredentials] = useState();
  const [ModalOpen, setModalOpen] = useState(false);
  const [TopID, setTopID] = useState('');
  const [TopUpName, setTopUpName] = useState('');
  const [topupAmount, settopupAmount] = useState('');
  const [transactionRefrence, settransactionRefrence] = useState('');
  const [TransactionRemark, setTransactionRemark] = useState('')
  const handleNavigation = (id) => {
    navigate(`/admin/billing/${id}`); // Navigating with ID

  };
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [Loading, setLoading] = useState(false);
  useEffect(() => {
    // Check if the Geolocation API is available
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          // Update latitude and longitude states
          setLatitude(position.coords.latitude);
          setLongitude(position.coords.longitude);
        },
        (err) => {
          setLerror(err.message);
        }
      );
    } else {
      setError("Geolocation is not supported by your browser");
    }
  }, []);

  const toggleRow = (id) => {
    setOpenRows((prev) => ({ ...prev, [id]: !prev[id] }));
  };
  const handleNavigate = (website) => {
    window.open(website, "_blank", "noopener,noreferrer");
  };
  useEffect(() => {
    // Retrieve user data from sessionStorage
    const userData = sessionStorage.getItem("AdminUser");
    if (userData) {
      setUser(JSON.parse(userData));
      console.log(User.pkid);
    } else {
      console.log("No user data found in sessionStorage.");
    }
  }, []);

  // fetch SuperAdmin Client Api call
  const FetchSuperAdminClientsCall = async () => {
    setLoading(true);
    try {
      const UserDetail = {
        // userid: User.pkid,
        userid: Admin.pkid,
        latitude: latitude,
        longitude: longitude,
      };

      const response = await axios.post(
        `${baseUrl}/api/SuperAdmin/getClientList`,
        UserDetail,
        config
      );
      if (response.data.responseCode === "00") {
        // toast.success(response.data.responseMessage);

        setClients(response.data.response);
        setLoading(false);
      } else {
        toast.error(response.data.responseMessage);
      }
    } catch (error) {
      toast.error("error");
      console.error("Error updating Admin login:", error);
    } finally {
      setLoading(false);
    }
  };
  // Add TopUp Client Api call
  const [isReportModalOpen, setIsReportModalOpen] = useState(false);
  const [topUpTransactions, setTopUpTransactions] = useState([]);
  const [isFetchingData, setIsFetchingData] = useState(false);

  const fetchTopUpReport = async (e, f) => {
    console.log(f);
    setTopUpName(f);
    setIsFetchingData(true);
    try {
      const response = await axios.post(
        `${baseUrl}/api/SuperAdmin/v1.0/creditTopupReport`,
        { adminId: Admin.pkid, userId: e },
        config
      );
      if (response.data.responseCode === "00") {
        setTopUpTransactions(response.data.data);
      } else {
        alert(response.data.responseMessage);
      }
    } catch (error) {
      alert("Error fetching data");
      console.error("Error:", error);
    } finally {
      setIsFetchingData(false);
    }
  };

  const AddTopUpCall = async (e) => {
    setLoading(true);
    try {
      const UserDetail = {
        adminId: Admin.pkid,
        userId: TopID,
        topupAmount: topupAmount,
        transactionReference: transactionRefrence,
        transactionRemarks: TransactionRemark,
      };

      const response = await axios.post(
        ` ${baseUrl}/api/SuperAdmin/v1.0/creditTopup`,
        UserDetail,
        config
      );
      if (response.data.responseCode === "00") {
        // toast.success(response.data.responseMessage);

        setLoading(false);
        settransactionRefrence('')
        setTransactionRemark('');
        settopupAmount("");
        setModalOpen(false);

      } else {
        toast.error(response.data.responseMessage);
      }
    } catch (error) {
      toast.error("error");
      console.error("Error updating Admin login:", error);
    } finally {
      setLoading(false);
    }
  };
  const ActivateClientApi = async (e) => {
    setLoading(true);
    try {
      const UserDetail = {
        userid: "string",
        status: "string"
      };

      const response = await axios.post(
        ` ${baseUrl}/api/SuperAdmin/v1.0/userActivateDeactivate`,
        UserDetail,
        config
      );
      if (response.data.responseCode === "00") {
        // toast.success(response.data.responseMessage);

        setLoading(false);


      } else {
        toast.error(response.data.responseMessage);
      }
    } catch (error) {
      toast.error("error");
      console.error("Error updating Admin login:", error);
    } finally {
      setLoading(false);
    }
  };

  function TopUpModal(id, name) {
    setModalOpen(true);
    setTopID(id);
    setTopUpName(name);

  }

  useEffect(() => {
    // Check if the Geolocation API is available
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          // Update latitude and longitude states
          setLatitude(position.coords.latitude);
          setLongitude(position.coords.longitude);
        },
        (err) => {
          setLerror(err.message);
        }
      );
    } else {
      setError("Geolocation is not supported by your browser");
    }
    // FetchClientCall();
    FetchSuperAdminClientsCall();
  }, []);
  useEffect(() => {
    setAppId(Credentials?.app_id);
    setBusinessAccId(Credentials?.business_acc_id);
    setPhoneNo(Credentials?.phone_no_id);
    setToken(Credentials?.token);
  }, [Credentials]);
  //  navigation for the new dashboard page
  const navigate = useNavigate();


  const ClientStatusSwitch = ({ client }) => {
    const [status, setStatus] = useState(client.status); // "Activate" or "Deactivate"
    const [loading, setLoading] = useState(false);

    const handleSwitchChange = async () => {
      const newStatus = status === "Activate" ? "Deactivate" : "Activate";

      const result = await Swal.fire({
        title: `Are you sure you want to ${newStatus} this client?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: `Yes, ${newStatus}`,
        cancelButtonText: "Cancel",
      });

      if (result.isConfirmed) {
        setLoading(true);
        try {
          const UserDetail = {
            userid: client.id,
            status: newStatus,
          };

          const response = await axios.post(
            `${baseUrl}/api/SuperAdmin/v1.0/userActivateDeactivate`,
            UserDetail,
            config
          );

          if (response.data.responseCode === "00") {
            toast.success(response.data.responseMessage);
            setStatus(newStatus);
          } else {
            toast.error(response.data.responseMessage);
          }
        } catch (error) {
          toast.error("Something went wrong");
          console.error("Error activating/deactivating client:", error);
        } finally {
          setLoading(false);
          FetchSuperAdminClientsCall()
        }
      }
    };

    return (
      <div className="form-switch">
        <input
          className="form-check-input"
          type="checkbox"
          role="switch"
          checked={status === "Activate"}
          onChange={handleSwitchChange}
          disabled={loading}
        />

      </div>
    );
  };


  return (
    <div className="marginRight" style={{ background: 'rgba(214, 233, 254, 0.23)' }} >
      <div className="profile-section-whatsapp">

        <div className=" d-flex align-items-center">
          <FaWhatsapp size={46} className="me-2" />
          <h1 className="text-muted">WhatsApp</h1>
        </div>

        <hr className="profile-divider" />

        <Tab.Container defaultActiveKey="profile">
          <Nav variant="tabs" className="profile-tabs">
            <Nav.Item>
              <Nav.Link eventKey="profile">
                <FontAwesomeIcon icon={faUser} className="me-2" />
                Users
              </Nav.Link>
            </Nav.Item>

          </Nav>

          <Tab.Content className="tab-content-section">
            <Tab.Pane eventKey="profile">
              <Form className="profile-form-whatsapp rounded bg-white">
                <div
                  className="bg-white"
                // style={{ width: "80%" }}
                >
                  <h4 className="text-center text-dark ">All Clients</h4>
                  <hr />

                  {Loading ? (
                    <div class="d-flex justify-content-center">
                      <div class="spinner-grow text-success " role="status">
                        <span class="visually-hidden">Loading...</span>
                      </div>
                    </div>
                  ) : (
                    <div className="overflow-x-auto">
                      <table className="min-w-full border border-gray-300 table table-striped table-hover text-center table-bordered">
                        <thead>
                          <tr className="bg-gray-200">
                            <th className="">ID</th>
                            <th className="">Activate Client</th>
                            <th className="">Client Name</th>
                            <th className="">Mobile</th>
                            <th className="">User Type</th>
                            <th className="">OB Type</th>
                            <th className="">OB By</th>
                            <th className="">Credit</th>
                            <th className="">Status</th>
                            <th className="">Created On</th>
                            <th className="">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {Clients.map((client) => (
                            <tr key={client.id} className="text-center">
                              <td className="">{client.id}</td>
                              <td className=""> <ClientStatusSwitch client={client} /></td>
                              <td className="">
                                {client.client_name}
                              </td>
                              <td className="">
                                {client.client_mobile}
                              </td>
                              <td className="">
                                {client.userType}
                              </td>
                              <td>{client.onboardingType}</td>
                              <td>{client.onboardedBy == "" ? "N/A" : client.onboardedBy}</td>
                              <td>{client.credit}</td>
                              <td className="">
                                {client.status === "Activate" ? (
                                  <span class="badge text-bg-success">
                                    Active
                                  </span>
                                ) : (
                                  <span class="badge text-bg-danger">
                                    Deactive
                                  </span>
                                )}
                              </td>
                              <td className="">
                                {client.createdOn}
                              </td>
                              <td>
                                <div className="d-flex">
                                
  <div className="flex flex-col sm:flex-row items-center justify-center gap-2">
    <Button
      variant="outline-danger"
      size="sm"
      className="cursor-pointer px-2 py-1 flex items-center gap-1 me-1"
      onClick={() => handleNavigation(client.id)}
    >
      <FontAwesomeIcon className="me-1" icon={faPen} />
      <span>Credential</span>
    </Button>

    <Button
      variant="outline-success"
      size="sm"
      className="cursor-pointer px-2 py-1 flex items-center gap-1 me-1"
      onClick={() => TopUpModal(client.id, client.client_name)}
    >
      <FontAwesomeIcon className="me-1" icon={faMoneyBillTransfer} />
      <span>Add TopUp</span>
    </Button>

    <Button
      variant="outline-primary"
      size="sm"
      className="cursor-pointer px-2 py-1 flex items-center gap-1 me-1"
      onClick={() => {
        setIsReportModalOpen(true);
        fetchTopUpReport(client.id, client.client_name);
      }}
    >
      <FontAwesomeIcon className="me-1" icon={faFileLines} />
      <span>Report</span>
    </Button>
  </div>


                                </div>

                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>


              </Form>
            </Tab.Pane>


          </Tab.Content>
        </Tab.Container>
      </div>
      <NoIndex />
      {ModalOpen && (
        <div
          className="modal show d-block"
          tabIndex="-1"
          role="dialog"
          style={{
            backgroundColor: "rgba(0, 0, 0, 0.5)",
          }}
        >
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Top Up to {TopUpName}</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setModalOpen(false)}
                ></button>
              </div>
              <div className="modal-body">
                <form>
                  <div className="mb-3">
                    <label className="form-label">Top Up Amount</label>
                    <input
                      type="number"
                      className="form-control"
                      value={topupAmount}
                      onChange={(e) => settopupAmount(e.target.value)}
                    />
                    <div className="form-text">Enter Top Up Amount Here.</div>
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Transaction Reference</label>
                    <input
                      type="text"
                      className="form-control"
                      value={transactionRefrence}
                      onChange={(e) => settransactionRefrence(e.target.value)}
                    />
                  </div>
                  <div className="form-floating">
                    <textarea
                      className="form-control"
                      placeholder="Leave a comment here"
                      id="floatingTextarea"
                      value={TransactionRemark}
                      onChange={(e) => setTransactionRemark(e.target.value)}
                    />
                    <label htmlFor="floatingTextarea">Add Remark Here</label>
                  </div>
                </form>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setModalOpen(false)}
                >
                  Close
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={AddTopUpCall}
                >
                  Add Top Up
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {isReportModalOpen && (
        <div className="marginRight"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            style={{
              background: "#fff",
              padding: "20px",
              borderRadius: "8px",
              width: "60%",
              maxHeight: "80%",
              overflowY: "auto",
            }}
          >
            <h2 style={{ textAlign: "center", marginBottom: "10px" }}>
              {TopUpName} - Top Up Report
            </h2>
            {isFetchingData ? (
              <div style={{ textAlign: "center", padding: "20px" }}>Loading...</div>
            ) : (
              <table className="table table-bordered" style={{ width: "100%", borderCollapse: "collapse" }}>
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Amount</th>
                    <th>Transaction ID</th>
                    <th>Reference ID</th>
                    <th>Created On</th>
                    <th>Updated On</th>
                    <th>Remarks</th>
                  </tr>
                </thead>
                <tbody>
                  {topUpTransactions?.map((item) => (
                    <tr key={item.id}>
                      <td>{item.id}</td>
                      <td>{item.amount}</td>
                      <td>{item.transaction_id || "N/A"}</td>
                      <td>{item.reference_id}</td>
                      <td>{item.created_on}</td>
                      <td>{item.updated_on}</td>
                      <td>{item.remarks}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
            <button
              onClick={() => setIsReportModalOpen(false)}
              style={{
                marginTop: "10px",
                padding: "8px 16px",
                backgroundColor: "#dc3545",
                color: "#fff",
                border: "none",
                borderRadius: "5px",
                cursor: "pointer",
                display: "block",
                marginLeft: "auto",
              }}
            >
              Close
            </button>
          </div>
        </div>
      )}


    </div>
  );
};

export default ClientAccordionTable;
